import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './_metronic/shared/http/auth.guard';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'callback',
    loadChildren: () =>
      import('./_metronic/shared/sso/sso.module').then((m) => m.SsoModule),
  },
  {
    path: 'callbackmsal',
    loadChildren: () =>
      import('./_metronic/shared/sso-msal/sso-msal.module').then((ss) => ss.SsoMsalModule),
  },
  {
    path: '',
    canActivate: [
      AuthGuard
      ,MsalGuard
    ],
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],  // Lazy module with PreloadAllModules
  exports: [RouterModule],
})
export class AppRoutingModule { }
